import { Directive, ElementRef, HostListener, inject, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCurrencyFormatter]',
  standalone: true
})
export class CurrencyFormatterDirective implements OnInit {

  private el: HTMLInputElement;
  private elementRef = inject(ElementRef);
  private control = inject(NgControl);

  constructor() {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit(): void {
    console.log('Inicializando CurrencyFormatterDirective con valor:', this.control.control?.value);
    this.formatValue(this.control.control?.value);
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    console.log('Evento de input detectado:', event);
    const value = (event.target as HTMLInputElement)?.value ?? '';
    this.formatValue(value);
  }

  private formatValue(value: string | number | null | undefined): void {

    if (value == null || value === '') {
      this.control.control?.setValue(null);
      this.el.value = '';
      return;
    }

    // Normalizar: quitar el símbolo $ y espacios, eliminar separadores de miles (puntos)
    // y convertir la coma decimal a punto antes de parsear.
    let raw = typeof value === 'string' ? value : String(value);
    raw = raw.replace(/\$/g, '').replace(/\s/g, '');
    // Quitar puntos (separadores de miles) y convertir coma decimal a punto
    raw = raw.replace(/\./g, '').replace(/,/g, '.');

    const num = parseFloat(raw as string);
    if (!isNaN(num)) {
      // Actualizar el model (emitEvent true) para que componentes que usan ngModel reciban el valor numérico
      this.control.control?.setValue(num);
      const formatted = '$' + new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(num);
      // Dejar que Angular procese el ngModelChange y luego re-aplicar el formato en el input
      setTimeout(() => {
        this.el.value = formatted;
      }, 0);
    } else {
      this.control.control?.setValue(null);
      this.el.value = '';
    }
  }
}